import { postRequest } from "../utils/api";

export const recordMovementsApi = {
  addRecordMovements: (body) => postRequest("/record/movements", body),
};
